<template>
  <div class="sign-in">
    <div class="sign-in-container">
      <img
        alt="Logo"
        src="../assets/logo_large.svg"
        class="sign-in-logo-image"
      />
      <h3 class="sign-in-header"><strong>Login to</strong> your account</h3>
      <div v-if="error">{{ error.message }}</div>
      <div class="sign-in-auth-container">
        <button @click="signIn" class="sign-in-btn">
          <img
            width="18"
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt="google-icon"
            class="google-icon"
          />
          Sign in with Google
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { auth, firebase } from '../Firebase'
import * as Firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'

const ui = new Firebaseui.auth.AuthUI(auth)

export default {
  data() {
    return {
      email: '',
      password: '',
      error: '',
      ui: null
    }
  },
  methods: {
    async pressed() {
      auth.signInWithEmailAndPassword(this.email, this.password)
    },
    routeTo(path) {
      this.$router.replace({ path: path })
    },
    signIn() {
      const that = this
      auth.signInWithPopup(new firebase.auth.GoogleAuthProvider()).then(
        function (result) {
          that.$router.push('/')
        },
        function (error) {}
      )
    }
  }
}
</script>

<style scoped>
.google-icon {
  margin-right: 12px;
}
.sign-in-btn {
  background-color: #ffffff;
  border-radius: 2px;
  color: #000;
  font-weight: 500;
  height: auto;
  line-height: normal;
  max-width: 220px;
  min-height: 40px;
  padding: 8px 16px;
}
.sign-in {
  display: flex;
  width: auto;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url('../assets/bg_signIn.jpg');
  background-color: #cccccc;
  background-repeat: stretch;
}
.sign-in .sign-in-container {
  display: flex;
  width: 100%;
  max-width: 500px;
  height: 400px;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  background-color: white;
  box-shadow: 0px 0px 139px rgba(0, 0, 0, 0.316597);
  border-radius: 4px;
  padding: 24px;
  margin: 12px;
}
.sign-in .sign-in-auth-container {
  margin-top: 20px;
  margin-bottom: 20px;
}

.sign-in .sign-in-header {
  width: 60%;
  color: black;
  font-weight: normal;
}
.sign-in .sign-in-form-container {
  visibility: hidden;
}
</style>
